module.exports = "/fast-coin/img/coin/anim/in/coin_in_010.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/in/coin_in_010.png
// module id = 2280
// module chunks = 5